import { getSvgFill } from "utils"

const LoseWeight = ({ isSelected }: { isSelected: boolean }) => {
  const { pathFill } = getSvgFill(isSelected)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.027 1.08416C10.3602 0.939797 10.7545 0.983612 11.04 1.19672C11.2118 1.3249 11.4061 1.46522 11.6179 1.61817C12.8829 2.53168 14.7721 3.89596 16.2087 5.81873C17.0824 6.98804 17.7822 8.50906 18.258 9.74321C18.398 10.1062 18.5206 10.4499 18.6245 10.76C19.0836 10.2424 19.5265 9.49205 19.6674 8.41295C19.7162 8.0391 20.0221 7.73607 20.426 7.66144C20.8299 7.58681 21.2407 7.75742 21.4446 8.08457C21.8261 8.69628 22.0787 9.1059 22.3249 9.62124C22.5674 10.129 22.7975 10.7263 23.1593 11.7198C23.9264 13.8262 24 15.2067 24 16.464C24 21.8283 19.2535 26 13.5001 26C7.77437 26 3 22.0389 3 16.6501C3 15.43 3.14364 13.5915 4.11345 12.1508C4.79008 11.1457 5.26951 10.6756 5.87726 10.0798C6.06028 9.90038 6.25494 9.70953 6.47014 9.48923C6.64059 9.31473 6.77998 9.17457 6.89831 9.0556C7.14646 8.80609 7.30203 8.64966 7.45755 8.46466C7.66631 8.21634 7.87027 7.91755 8.25702 7.25302C8.58768 6.68487 8.89944 5.77765 9.12778 4.7552C9.3536 3.74404 9.48159 2.69396 9.48159 1.8721C9.48159 1.53526 9.69393 1.22853 10.027 1.08416Z"
        fill={pathFill}
        fillOpacity={isSelected ? 1 : 0.6}
      />
    </svg>
  )
}

export default LoseWeight
